import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc"; // Google Icon
import { FaApple, FaMicrosoft } from "react-icons/fa"; // Apple Icon
import { Link, useParams } from "react-router-dom";

const ForgotPass = () => {
  const { type } = useParams();
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Integrate with backend API for password reset
    console.log("Password reset request for:", email);
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl text-black font-semibold text-center mb-6">
          Forgot Password
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Email Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Email *
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full text-black mt-1 p-2 border border-gray-300 rounded-md focus:ring focus:ring-green-300 placeholder:text-gray-400"
              required
            />
          </div>

          {/* Forgot Password Link */}
          <div className="text-right text-sm text-green-600 cursor-pointer">
            <Link to={`/auth/login/${type}`}>Return to login</Link>
          </div>

          {/* Submit Button */}
          <button type="submit" className="w-full bg-teal-600 text-white py-2 mt-4 rounded-md hover:bg-teal-700 transition">
            Send Code
          </button>
        </form>

        {/* OR Separator */}
        <div className="flex items-center my-4">
          <hr className="flex-grow border-gray-300" />
          <span className="px-2 text-gray-500 text-sm">OR</span>
          <hr className="flex-grow border-gray-300" />
        </div>

        {/* Social Logins */}
        <button className="w-full bg-black text-white py-2 rounded-md flex items-center justify-center gap-2 mb-2">
          <FcGoogle className="w-5 h-5" />
          Login with Google
        </button>

        <div className="flex gap-2">
          <button className="flex-1 bg-black text-white py-2 rounded-md flex items-center justify-center gap-2">
            <FaApple className="w-5 h-5" />
            Apple
          </button>
          <button className="flex-1 bg-black text-white py-2 rounded-md flex items-center justify-center gap-2">
            <FaMicrosoft className="w-5 h-5 text-blue-500" />
            Microsoft
          </button>
        </div>

        {/* Sign Up Link */}
        <p className="text-center text-sm text-gray-600 mt-4">
          Don't have an account?{" "}
          <span className="text-green-600 cursor-pointer">
            <Link to={`/auth/signup/${type}`}>Create account</Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default ForgotPass;
